import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { savePaymentIntentId, savePaymentWay, saveTransactionId } from "../../redux/UserDataSlice";
import { useSelector } from "react-redux";
import { endpoint } from "../../assets/api/endpoint";
import { apiHandler } from "../../assets/api";

const CheckoutForm = ({ clientSecret }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { gameCreatePayload, accessToken, transactionId, paymentWay, gameIdForRequestToJoin } = useSelector((state) => state.loginInfo);

  const joinedGamePayement = async (payload ) => {
    try {
      const result = await apiHandler({
        url: `${endpoint.GAME_REQUESTED_TO_JOIN}`,
        data: payload,
        method: "POST",
        authToken: accessToken?.accessToken,
      });

      if (result?.data.code !== 500) {
        dispatch(savePaymentWay(''));
        navigate(-1);
        toast.success("Successfully joined the game!");
      }
    } catch (error) {
      toast.error("Failed to join the game.");
    }
  }
  const notificationPayment = async(payload)=>{
    try {
      const result = await apiHandler({
        url: `${endpoint?.PAYMENT_NOTIFICATION_ONE_TIME_API}`,
        data: payload,
        method: "POST",
        authToken: accessToken?.accessToken,
      });
      if (result?.data.code !== 500) {
        dispatch(savePaymentWay(''));
        navigate('/notification');
        toast.success( result?.data?.message || "Successfully joined the game!");
      }
    } catch (error) {
      toast.error("Failed to join the game.");
    }

  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const isSetupIntent = clientSecret.startsWith("seti_");
    try {
      let result;

      if (isSetupIntent) {
        result = await stripe.confirmSetup({
          elements,
          confirmParams: {},
          redirect: "if_required",
        });
      } else {
        result = await stripe.confirmPayment({
          elements,
          confirmParams: {},
          redirect: "if_required",
        });
      }
      if (result.error) {
        toast.error(result.error.message);
      } else {
        if (paymentWay == 'createGame') {
          const updatedGameCreatePayload = {
            ...gameCreatePayload,
            paymentIntentId: result?.paymentIntent?.id || "",
            transactionId: transactionId
          };
          try {
            const result = await apiHandler({
              url: endpoint.CREATE_GAMES,
              method: "POST",
              data: updatedGameCreatePayload,
              authToken: accessToken.accessToken
            });
          
            const response = result.data;
            if (response && !response?.user_description) {
              toast.success(" Payment Successful and Game created successfully!");
              dispatch(savePaymentIntentId(''));
              dispatch(saveTransactionId(''));
              dispatch(savePaymentWay(''));
            } else {
              dispatch(savePaymentIntentId(''));
              dispatch(saveTransactionId(''));
              dispatch(savePaymentWay(''));
              toast.error(response?.user_description || "Failed to create game");
            }
          } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred while creating the game");
          }
          navigate(-1, {
            state: {
              paymentId: result?.paymentIntent?.id
            }
          });
        } else if(paymentWay == 'notification'){
          const payload = {
            gameId: gameIdForRequestToJoin ,
            paymentIntentId: result?.paymentIntent?.id || "" ,
            transactionId: transactionId
          }
         notificationPayment(payload)
        }else if(paymentWay == 'joinedGame'){
          const payload = {
            gameId: gameIdForRequestToJoin ,
            paymentIntentId: result?.paymentIntent?.id || "" ,
            transactionId: transactionId
          }
          joinedGamePayement(payload);
        }
        else{
          navigate('/explore');
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    }

    setLoading(false);
  };
 

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 500, margin: "0 auto" }}>
      <PaymentElement />
      <button
        type="submit"
        disabled={!stripe || loading}
        style={{
          marginTop: "20px",
          width: "100%",
          padding: "12px",
          backgroundColor: "#635BFF",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          fontSize: "16px",
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Processing..." : "Submit"}
      </button>
    </form>
  );
};

export default CheckoutForm;
